import webchatSoundImg from '~/assets/announcements/webchat-sound.png'
import conversationInsightsImg from '~/assets/announcements/conversation-insights.png'
import agentOverviewImg from '~/assets/announcements/agent-overview-revamp.png'
import knowledgeBaseImg from '~/assets/announcements/knowledge-base.png'
import billingRefreshImg from '~/assets/announcements/billing-refresh.png'
import webchatConfigRefreshImg from '~/assets/announcements/webchat-config-refresh.png'
import autoRechargeAddonsImg from '~/assets/announcements/auto-recharge-addons.png'
import webchatV34 from '~/assets/announcements/webchat-v3.4.png'
import { FileRouteTypes } from '~/routeTree.gen'

export type Announcement = {
  id: string
  asset: string
  title: string
  description: string
  releaseDate: string
  daysActive: number
  instructions?: string
  navigateTo: FileRouteTypes['to']
  navigateSearch?: Record<string, boolean>
  confirmLabel: string
  cancelLabel: string
}

export type AnnouncementId = (typeof ANNOUNCEMENTS)[number]['id']
export type AnnouncementsSearch = Extract<(typeof ANNOUNCEMENTS)[number], { navigateSearch: object }>['navigateSearch']

export const ANNOUNCEMENTS = [
  {
    id: 'webchat-sound',
    asset: webchatSoundImg,
    title: 'Webchat sound alerts',
    description: 'Switch on sound notifications to get an audible alerts whenever a new message comes in.',
    instructions: 'Requires webchat v3.3+',
    releaseDate: '2025-10-07',
    daysActive: 30,
    navigateTo: '/workspaces/$workspaceId/bots/$botId/webchat/v2/identity',
    confirmLabel: 'Enable Sound',
    cancelLabel: 'Not now',
  },
  {
    id: 'conversation-insights',
    asset: conversationInsightsImg,
    title: 'Meet AI Insights',
    description:
      'Insights generates a title, a concise summary, and runs sentiment analysis on each conversation so you can have full visibility into the conversations your agent is having.',
    instructions: 'This feature consumes AI Spend.',
    releaseDate: '2025-11-03',
    daysActive: 30,
    navigateTo: '/workspaces/$workspaceId/bots/$botId/conversations',
    navigateSearch: { aiInsights: true },
    confirmLabel: 'Enable',
    cancelLabel: 'Close',
  },
  {
    id: 'agent-overview',
    asset: agentOverviewImg,
    title: 'Improved Agent Dashboard',
    description:
      "We've refreshed the design of your bot's overview in the Dashboard so you can more quickly understand how it's performing, recent changes, and active conversations.",
    releaseDate: '2025-10-30',
    daysActive: 30,
    navigateTo: '/workspaces/$workspaceId/bots/$botId/overview',
    confirmLabel: 'View',
    cancelLabel: 'Close',
  },
  {
    id: 'knowledge-base',
    asset: knowledgeBaseImg,
    title: 'Easier Knowledge Base Management',
    description: "You can now view, upload, and manage your agent's Knowledge Base files directly from the Dashboard.",
    releaseDate: '2025-10-30',
    daysActive: 30,
    navigateTo: '/workspaces/$workspaceId/bots/$botId/knowledge-bases',
    confirmLabel: 'View',
    cancelLabel: 'Close',
  },
  {
    id: 'billing-refresh',
    asset: billingRefreshImg,
    title: 'Keep Track of Payments',
    description: 'Download invoices, manage add-ons, update AI Spend, and review payment details from a single place.',
    releaseDate: '2025-11-07',
    daysActive: 30,
    navigateTo: '/workspaces/$workspaceId/billing',
    confirmLabel: 'View',
    cancelLabel: 'Close',
  },
  {
    id: 'webchat-config-refresh',
    asset: webchatConfigRefreshImg,
    title: 'Bring Your Brand to Every Chat',
    description:
      "Customize your agent's tone, personality, and Webchat's appearance to create conversations that look and feel naturally on-brand.",
    releaseDate: '2025-11-13',
    daysActive: 30,
    navigateTo: '/workspaces/$workspaceId/bots/$botId/webchat/v2/identity',
    confirmLabel: 'View',
    cancelLabel: 'Close',
  },
  {
    id: 'webchat-v3.4',
    asset: webchatV34,
    title: 'Webchat Improvements',
    description:
      'Smoother scrolling, the ability to paste images from your clipboard into chat, improved typing indicators, media rendering, performance, and reliability',
    instructions: 'Available in webchat v3.4',
    releaseDate: '2025-11-14',
    daysActive: 30,
    navigateTo: '/workspaces/$workspaceId/bots/$botId/webchat/v2/deploy-settings',
    confirmLabel: 'Go to Settings',
    cancelLabel: 'Close',
  },
  {
    id: 'auto-recharge-addons',
    asset: autoRechargeAddonsImg,
    title: 'Automatically purchase add-ons with Auto Recharge',
    description:
      'Never worry about interruptions. Auto Recharge automatically purchases Add-ons when you drop below a set usage threshold.',
    releaseDate: '2025-11-24',
    daysActive: 30,
    navigateTo: '/workspaces/$workspaceId/billing',
    confirmLabel: 'Enable Auto Recharge',
    cancelLabel: 'Close',
  },
] as const
